import { Rpc } from "../rpc";
import { ValueWrapper } from "../ValueWrapper";

export class AuthRpc {

    public static login(email: string, password: string): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/auth/login", { email: email, password: password });
    }

    public static timezones(): Promise<TimeZonesResponse> {
        return Rpc.GET("/rpc/auth/timezones");
    }

    public static register(req: RegisterRequest): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/auth/register", req);
    }

    public static invitationInfo(token: string): Promise<InvitationInfoResponse> {
        return Rpc.GET("/rpc/auth/invitationInfo?token=" + encodeURIComponent(token));
    }

    public static acceptInvitation(req: AcceptInvitationRequest): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/auth/acceptInvitation", req);
    }

    public static requestPasswordReset(email: string): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/auth/requestPasswordReset", { email: email });
    }

    public static passwordResetInfo(token: string): Promise<PasswordResetInfoResponse> {
        return Rpc.GET("/rpc/auth/passwordResetInfo?token=" + encodeURIComponent(token));
    }

    public static resetPassword(req: ResetPasswordRequest): Promise<ValueWrapper<boolean>> {
        return Rpc.POST("/rpc/auth/resetPassword", req);
    }

    private constructor() {}

}

export interface TimeZonesResponse {

    readonly items: TimeZoneItem[];

}

export interface TimeZoneItem {

    readonly id: string;
    readonly label: string;

}

export interface RegisterRequest {

    companyName: string;
    userName: string;
    email: string;
    password: string;
    timeZone: string;

}

export interface AcceptInvitationRequest {

    token: string;
    name: string;
    password: string;

}

export interface InvitationInfoResponse {

    readonly valid: boolean;
    readonly error?: string;
    readonly company?: string;
    readonly email?: string;
    readonly name?: string;

}

export interface ResetPasswordRequest {

    token: string;
    password: string;

}

export interface PasswordResetInfoResponse {

    readonly valid: boolean;
    readonly error?: string;

}
